import { Text } from 'app/design/primitives/text';
import { i18n } from 'app/localization/i18n';
import { LogoComponent } from '../mobile/logo';
import type { SpecificRouteProp } from 'app/types/navigation';

export function HeaderTitle({ route }: { route: SpecificRouteProp }) {
  if (i18n.exists('headerTitle', { ns: route.name })) {
    return (
      <Text color="white-label.header.on-header" variant="bodyXLargeMedium">
        {i18n.t('headerTitle', { ns: route.name })}
      </Text>
    );
  }
  return <LogoComponent />;
}
